import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MiniLoadingComponent } from '../loaders/mini-loader/mini-loading.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { distinctUntilChanged, finalize, Subject, takeUntil } from 'rxjs';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-search-suggestions',
  standalone: true,
  imports: [MiniLoadingComponent, LazyLoadImageModule],
  templateUrl: './search-suggestions.component.html',
  styleUrl: './search-suggestions.component.scss',
})
export class SearchSuggestionsComponent {
  constructor(
    private _router: Router,
    private http: HttpService,
    private helper: HelperService,
  ) {}
  loader;
  experts = [];
  @Input() show;
  @Input() extra: boolean = false;
  search: any;
  @Input() set searchState(data: any) {
    if (data) {
      this.searchMentor(data);
    } else {
      this.experts = [];
    }
  }
  @Output() showEmit: EventEmitter<any> = new EventEmitter<any>();
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  gotoprofile(item) {
    this.showEmit.emit();
    this._router.navigateByUrl('/' + item.uniqueName);
  }
  searchMentor(search: string): void {
    this.show = true;
    this.loader = true;
    if (search != null) {
      const body = {
        pageNumber: 1,
        pageSize: 15,
        search: search,
      };
      this.http
        .alternateLoaderPost('api/home/searchMentors_v2', body, false, false)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loader = false;
          }),
          distinctUntilChanged(
            (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
          ),
        )
        .subscribe({
          next: (response: any) => {
            if (response.status) {
              this.experts = response.objModelList;
            }
          },
          error: (error: any) => {
            if (error.error.userMessage) {
              this.experts = [];
            }
          },
        });
    }
  }
  showAddCreator() {
    this.showEmit.emit();
    this.helper.showModal(true, 'creatorInfo');
  }
}
